import { Reducer } from 'redux';
import { DataHoraordemDeCargaState, DataHoraordemDeCargaTypes } from './types';

const INITIAL_STATE: DataHoraordemDeCargaState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<DataHoraordemDeCargaState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DataHoraordemDeCargaTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case DataHoraordemDeCargaTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };

    case DataHoraordemDeCargaTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };

    case DataHoraordemDeCargaTypes.CLEAN_MOVIENTRADA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
